import { createSelector } from 'reselect';
import { State, AppState } from '../constants';

const getAppState = ({ app }: State) => app;

export const getFullscreen = createSelector(
    getAppState,
    ({ fullscreen }) => fullscreen
);
